import script from "./suspend-left.vue?vue&type=script&setup=true&lang=js"
export * from "./suspend-left.vue?vue&type=script&setup=true&lang=js"

import "./suspend-left.vue?vue&type=style&index=0&id=3d28d684&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d28d684"]])

export default __exports__